<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ params.value }}</span>
    </vs-chip>
</template>

<script>
export default { 
  name: 'CellRendererStatus',
  computed: {
    chipColor () {
      return (value) => {
        if (value > 30) return 'success'
        else if (value <= 30 && value >= -0.01) return 'warning'
        else if (value < 0.1) return 'danger'
        else return 'white'
      }
    }
  }
}
</script>
